<template>
  <div class="customer-match">
    <div class="flex justify-between align-middle">
      <div class="flex flex-column justify-between">
        <p class="mb-20">{{ customer.firstname + ' ' + customer.lastname }}</p>
        <div>
          <p>{{ customer.cellphone }}</p>
          <p>{{ customer.email }}</p>
        </div>
      </div>
      <div style="width: 200px;" class="mr-5 text-right">
        <p class="btn pointer" @click="selectCustomer(customer)">VÄLJ KUND</p>
      </div>
    </div>
  </div>

</template>
<script>

export default {
  name: 'customerMatch',
  props: {
    customer: {
      type: Object,
    },
    addCustomerData : {
      type : Function
    }
  },
  methods: {
    selectCustomer(customer) {
      this.addCustomerData(customer)
    },
  },
};
</script>
<style>
.customer-match {
  background-color: var(--fasad-grey-1);
  padding: 25px 15px;
  border-bottom: 0.1px #fff solid
}

.btn {
  color: var(--fasad-orange);
}
</style>

